import OnlineBookingSwitch from "../../components/OnlineBookingSwitch";
import OrganizerPillSelect from "../../components/OrganizerPillSelect";
import OrganizerTimePillSelect from "../../components/OrganizerTimePillSelect";
import "../../components/EventFormPickers.css";
import { MultiPillDropdown } from "../../../pages/reservas/components/ReservaShared";
import AvisoSenasBloqueadas from "../../components/AvisoSenasBloqueadas";
import {
	BloqueUbicacion,
	Campo,
	PasoContacto,
	PasoFotos,
	PasoPoliticas,
} from "../../reservas/primerUso/barPasos";
import {
	ALLOWED_DURATIONS,
	DURATION_LABELS,
	ENCLOSURES,
	ENCLOSURE_LABELS,
	SERVICES,
	SERVICE_LABELS,
	SPORTS,
	SPORT_LABELS,
	SURFACES,
	SURFACE_LABELS,
} from "../../../constants/courtDomain";
import {
	DIAS_SEMANA,
	categoriasDe,
	deporteDe,
	duracionesDe,
	faltaCanchas,
	faltaClub,
	faltaContacto,
	faltaDetalle,
	faltaHorarios,
	faltaReglas,
	nuevaCancha,
	nuevaRegla,
	num,
	turnosDe,
} from "./clubPayload";

const plata = (n) => `$ ${Number(n || 0).toLocaleString("es-AR")}`;
export const alternar = (lista, v) =>
	lista.includes(v) ? lista.filter((x) => x !== v) : [...lista, v];

export const Chip = ({ activo, onClick, children, label }) => (
	<button
		type="button"
		className="pu-mode"
		style={{ padding: "6px 12px" }}
		aria-pressed={activo}
		aria-label={label}
		onClick={onClick}
	>
		{children}
	</button>
);

export const Dinero = ({
	value,
	onChange,
	label,
	disabled,
	placeholder = "0",
}) => (
	<div className="pu-money">
		<span>$</span>
		<input
			className="ef-input"
			type="number"
			min="0"
			aria-label={label}
			value={value}
			disabled={disabled}
			placeholder={placeholder}
			onChange={(e) => onChange(e.target.value)}
		/>
	</div>
);

const SIN = { value: "", label: "Sin definir" };

/* ---- 1. Tu club: name + Ubicación ---- */
const PasoClub = ({ data: d, set, states }) => (
	<>
		<Campo
			label="Nombre del club"
			hint={
				d.nombreDelPortal && d.nombre === d.nombreDelPortal
					? "Del portal. Podés cambiarlo."
					: undefined
			}
		>
			<input
				className="ef-input"
				value={d.nombre}
				onChange={(e) => set({ nombre: e.target.value })}
				placeholder="Ej: Padel Norte Club"
			/>
		</Campo>
		<BloqueUbicacion data={d} set={set} states={states} entityLabel="club" />
	</>
);

/* ---- 2. ¿Cuándo se alquila?: sports, days, hours and durations (same controls and classes as the club form) ---- */
const OPCIONES_DEPORTE = SPORTS.map((s) => ({
	value: s,
	label: SPORT_LABELS[s] || s,
}));
const OPCIONES_DURACION = ALLOWED_DURATIONS.map((m) => ({
	value: String(m),
	label: DURATION_LABELS[m] || `${m} min`,
}));

const PasoHorarios = ({ data: d, set }) => {
	const durs = duracionesDe(d);
	const turnos = turnosDe(d.desde, d.hasta, durs[0] ?? 60, 12);
	return (
		<>
			<div className="pu-grid-2">
				<div className="zr-field">
					<span className="zr-field__label">Deportes</span>
					<MultiPillDropdown
						iconName="ball"
						ariaLabel="Deportes"
						value={d.deportes}
						options={OPCIONES_DEPORTE}
						placeholder="Seleccioná deportes"
						onChange={(val) => set({ deportes: val })}
					/>
					<p className="ef-footnote">
						Los que se juegan en tu club. Después asignás uno a cada cancha.
					</p>
				</div>
				<div className="zr-field">
					<span className="zr-field__label">Duraciones permitidas</span>
					<MultiPillDropdown
						iconName="clock"
						ariaLabel="Duraciones permitidas"
						value={d.duraciones.map(String)}
						options={OPCIONES_DURACION}
						placeholder="Seleccioná duraciones"
						onChange={(val) => set({ duraciones: val.map(Number) })}
					/>
					<p className="ef-footnote">El cliente elige entre las que marques.</p>
				</div>
			</div>
			<div className="zr-field">
				<span className="zr-field__label">Días que abrís</span>
				<div className="zr-week pu-week">
					{DIAS_SEMANA.map((x) => {
						const on = d.dias.includes(x.weekday);
						return (
							<button
								key={x.weekday}
								type="button"
								aria-pressed={on}
								aria-label={x.largo}
								className={"zr-week__day" + (on ? " zr-week__day--on" : "")}
								onClick={() => set({ dias: alternar(d.dias, x.weekday) })}
							>
								{x.corto}
							</button>
						);
					})}
				</div>
			</div>
			<div className="pu-times">
				<div className="zr-field">
					<span className="zr-field__label">Abre</span>
					<OrganizerTimePillSelect
						triggerClassName="zr-day-row__time"
						ariaLabel="Abre"
						value={d.desde}
						onChange={(val) => set({ desde: val })}
						quarterHours
					/>
				</div>
				<div className="zr-field">
					<span className="zr-field__label">Cierra</span>
					<OrganizerTimePillSelect
						triggerClassName="zr-day-row__time"
						ariaLabel="Cierra"
						value={d.hasta}
						onChange={(val) => set({ hasta: val })}
						quarterHours
					/>
				</div>
			</div>
			<div className="zr-field">
				<span className="zr-field__label">{`Turnos de ${durs[0] ?? 60} min de un día`}</span>
				<div className="pu-slots" aria-live="polite">
					{turnos.length ? (
						turnos.map((t) => (
							<span key={t} className="pu-slot">
								{t}
							</span>
						))
					) : (
						<span className="pu-empty">Revisá el horario</span>
					)}
				</div>
			</div>
		</>
	);
};

/* ---- 3. Tus canchas y precios ---- */
const DIAS_TXT = (dias) =>
	dias.length === 7
		? "Todos los días"
		: DIAS_SEMANA.filter((x) => dias.includes(x.weekday))
				.map((x) => x.corto)
				.join(" ");

const PasoCanchas = ({ data: d, set }) => {
	const durs = duracionesDe(d);
	const setCancha = (i, patch) =>
		set({
			canchas: d.canchas.map((c, j) => (j === i ? { ...c, ...patch } : c)),
		});
	const setPrecio = (i, m, v) =>
		setCancha(i, { precios: { ...d.canchas[i].precios, [m]: v } });
	const deportes = [
		{ value: "", label: "Elegí" },
		...d.deportes.map((s) => ({ value: s, label: SPORT_LABELS[s] })),
	];
	return (
		<div className="pu-split">
			<div className="pu-body">
				<OnlineBookingSwitch
					checked={d.onlineBookingEnabled}
					onChange={(onlineBookingEnabled) => set({ onlineBookingEnabled })}
				/>
				<table className="pu-table">
					<thead>
						<tr>
							<th>Cancha</th>
							<th style={{ width: 150 }}>Deporte</th>
							<th style={{ width: 170 }}>Superficie</th>
							{durs.map((m) => (
								<th key={m} style={{ width: 120 }}>
									{m} min
								</th>
							))}
							<th style={{ width: 40 }} />
						</tr>
					</thead>
					<tbody>
						{d.canchas.map((c, i) => (
							<tr key={i}>
								<td>
									<input
										className="ef-input"
										aria-label="Nombre de la cancha"
										value={c.nombre}
										placeholder="Ej: Cancha 3"
										onChange={(e) => setCancha(i, { nombre: e.target.value })}
									/>
								</td>
								<td>
									<OrganizerPillSelect
										value={deporteDe(c, d)}
										options={deportes}
										placeholder="Elegí"
										onChange={(v) => setCancha(i, { deporte: v })}
									/>
								</td>
								<td>
									<OrganizerPillSelect
										value={c.superficie}
										placeholder="Sin definir"
										options={[
											SIN,
											...SURFACES.map((s) => ({
												value: s,
												label: SURFACE_LABELS[s],
											})),
										]}
										onChange={(v) => setCancha(i, { superficie: v })}
									/>
								</td>
								{durs.map((m) => (
									<td key={m}>
										<Dinero
											label={`Precio de ${c.nombre || "la cancha"} (${m} min)`}
											value={c.precios[m] ?? ""}
											onChange={(v) => setPrecio(i, m, v)}
										/>
									</td>
								))}
								<td>
									{d.canchas.length > 1 && (
										<button
											type="button"
											className="ef-btn ef-btn--ghost"
											aria-label={`Quitar ${c.nombre || "cancha"}`}
											onClick={() =>
												set({ canchas: d.canchas.filter((_, j) => j !== i) })
											}
										>
											×
										</button>
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<div className="pu-row-actions">
					<button
						type="button"
						className="ef-btn ef-btn--ghost"
						onClick={() =>
							set({
								canchas: [
									...d.canchas,
									nuevaCancha(`Cancha ${d.canchas.length + 1}`),
								],
							})
						}
					>
						Agregar cancha
					</button>
				</div>
			</div>
			<aside className="pu-summary" aria-label="Resumen">
				<dl style={{ margin: 0 }}>
					<dt>Club</dt>
					<dd>
						{d.nombre || "—"}
						<br />
						{d.address || "—"}
					</dd>
					<dt>Días</dt>
					<dd>{DIAS_TXT(d.dias) || "—"}</dd>
					<dt>Horario</dt>
					<dd>
						{d.desde} a {d.hasta}
					</dd>
					<dt>Canchas</dt>
					<dd>
						{d.canchas.map((c, i) => (
							<div key={i}>
								{c.nombre || "—"} ·{" "}
								{durs
									.map((m) => (num(c.precios[m]) ? plata(c.precios[m]) : "—"))
									.join(" / ")}
							</div>
						))}
					</dd>
				</dl>
			</aside>
		</div>
	);
};

/* ---- Optional: services + categories ---- */
const PasoServicios = ({ data: d, set }) => (
	<>
		<Campo
			label="Servicios del club"
			hint="Aparecen en los filtros de búsqueda."
		>
			<div className="pu-chips">
				{SERVICES.map((s) => (
					<Chip
						key={s}
						activo={d.servicios.includes(s)}
						onClick={() => set({ servicios: alternar(d.servicios, s) })}
					>
						{SERVICE_LABELS[s]}
					</Chip>
				))}
			</div>
		</Campo>
		<div style={{ maxWidth: 420 }}>
			<Campo
				label="Categorías de cancha (opcional)"
				hint="Sirven para agrupar canchas."
			>
				<input
					className="ef-input"
					value={d.categorias}
					placeholder="F5, F7 (separadas por coma)"
					onChange={(e) => set({ categorias: e.target.value })}
				/>
			</Campo>
		</div>
	</>
);

/* ---- Optional: detail of each court ---- */
const PasoDetalle = ({ data: d, set, ctx, senasBloqueadas }) => {
	const categorias = ctx?.categorias || categoriasDe("");
	const setCancha = (i, patch) =>
		set({
			canchas: d.canchas.map((c, j) => (j === i ? { ...c, ...patch } : c)),
		});
	const catOpciones = [
		{
			value: "",
			label: categorias.length ? "Sin categoría" : "Sin categorías cargadas",
		},
		...categorias.map((x) => ({ value: x, label: x })),
	];
	return (
		<>
			{senasBloqueadas && <AvisoSenasBloqueadas />}
			<table className="pu-table">
				<thead>
					<tr>
						<th>Cancha</th>
						<th style={{ width: 150 }}>Techado</th>
						<th style={{ width: 160 }}>Categoría</th>
						<th style={{ width: 90 }}>Iluminación</th>
						<th style={{ width: 230 }}>Seña</th>
					</tr>
				</thead>
				<tbody>
					{d.canchas.map((c, i) => (
						<tr key={i}>
							<td>
								<b>{c.nombre}</b>
								<br />
								<small>{SPORT_LABELS[deporteDe(c, d)] || ""}</small>
							</td>
							<td>
								<OrganizerPillSelect
									value={c.techado}
									placeholder="Sin definir"
									options={[
										SIN,
										...ENCLOSURES.map((s) => ({
											value: s,
											label: ENCLOSURE_LABELS[s],
										})),
									]}
									onChange={(v) => setCancha(i, { techado: v })}
								/>
							</td>
							<td>
								<OrganizerPillSelect
									value={c.categoria}
									placeholder="Sin categoría"
									disabled={!categorias.length}
									options={catOpciones}
									onChange={(v) => setCancha(i, { categoria: v })}
								/>
							</td>
							<td>
								<input
									type="checkbox"
									aria-label={`Iluminación de ${c.nombre}`}
									checked={c.luz}
									onChange={(e) => setCancha(i, { luz: e.target.checked })}
								/>
							</td>
							<td>
								<div className="pu-row-actions">
									<input
										type="checkbox"
										aria-label={`Requiere seña ${c.nombre}`}
										checked={c.requiereSena}
										disabled={senasBloqueadas}
										onChange={(e) =>
											setCancha(i, { requiereSena: e.target.checked })
										}
									/>
									{c.requiereSena ? (
										<Dinero
											label={`Monto de la seña de ${c.nombre}`}
											value={c.sena}
											onChange={(v) => setCancha(i, { sena: v })}
										/>
									) : (
										<small>Sin seña</small>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<p className="ef-hint">
				La seña aplica a todos los precios base de la cancha y no puede superar
				el precio más bajo.
				{!categorias.length &&
					" Para elegir categoría, cargalas antes en Servicios y categorías."}
			</p>
		</>
	);
};

/* ---- Optional: price rules by day and time ---- */
const DIAS_REGLA = [
	{ value: "", label: "Cualquier día" },
	...[...DIAS_SEMANA].map((x) => ({
		value: String(x.weekday),
		label: x.largo,
	})),
];

const PasoReglas = ({ data: d, set, senasBloqueadas }) => {
	const durs = duracionesDe(d);
	const setRegla = (i, patch) =>
		set({ reglas: d.reglas.map((r, j) => (j === i ? { ...r, ...patch } : r)) });
	return (
		<>
			{senasBloqueadas && <AvisoSenasBloqueadas />}
			<table className="pu-table">
				<thead>
					<tr>
						<th>Cancha</th>
						<th style={{ width: 110 }}>Duración</th>
						<th style={{ width: 150 }}>Día</th>
						<th style={{ width: 105 }}>Desde</th>
						<th style={{ width: 105 }}>Hasta</th>
						<th style={{ width: 120 }}>Precio</th>
						{!senasBloqueadas && <th style={{ width: 120 }}>Seña</th>}
						<th style={{ width: 40 }} />
					</tr>
				</thead>
				<tbody>
					{d.reglas.length === 0 && (
						<tr>
							<td colSpan={8} className="pu-empty">
								Sin reglas: rige el precio base.
							</td>
						</tr>
					)}
					{d.reglas.map((r, i) => (
						<tr key={i}>
							<td>
								<OrganizerPillSelect
									value={r.cancha}
									onChange={(v) => setRegla(i, { cancha: v })}
									options={d.canchas.map((c) => c.nombre.trim())}
								/>
							</td>
							<td>
								<OrganizerPillSelect
									value={r.dur}
									onChange={(v) => setRegla(i, { dur: Number(v) })}
									options={durs.map((m) => ({ value: m, label: `${m} min` }))}
								/>
							</td>
							<td>
								<OrganizerPillSelect
									value={r.dia}
									onChange={(v) => setRegla(i, { dia: v })}
									options={DIAS_REGLA}
								/>
							</td>
							<td>
								<OrganizerTimePillSelect
									triggerClassName="ef-date-pill-trigger"
									ariaLabel="Desde"
									value={r.desde}
									onChange={(val) => setRegla(i, { desde: val })}
								/>
							</td>
							<td>
								<OrganizerTimePillSelect
									triggerClassName="ef-date-pill-trigger"
									ariaLabel="Hasta"
									value={r.hasta}
									onChange={(val) => setRegla(i, { hasta: val })}
								/>
							</td>
							<td>
								<Dinero
									label="Precio de la regla"
									value={r.precio}
									onChange={(v) => setRegla(i, { precio: v })}
								/>
							</td>
							{!senasBloqueadas && (
								<td>
									<Dinero
										label="Seña de la regla"
										value={r.sena}
										placeholder="Sin seña"
										onChange={(v) => setRegla(i, { sena: v })}
									/>
								</td>
							)}
							<td>
								<button
									type="button"
									className="ef-btn ef-btn--ghost"
									aria-label="Quitar regla"
									onClick={() =>
										set({ reglas: d.reglas.filter((_, j) => j !== i) })
									}
								>
									×
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<div className="pu-row-actions">
				<button
					type="button"
					className="ef-btn ef-btn--ghost"
					onClick={() => set({ reglas: [...d.reglas, nuevaRegla(d)] })}
				>
					Agregar regla de precio
				</button>
			</div>
		</>
	);
};

export const pasosClub = ({ states, senasBloqueadas }) => ({
	req: [
		{
			id: "club",
			titulo: "Tu club",
			bajada:
				"El nombre viene del portal y lo podés cambiar. Después ubicá el club en el mapa.",
			render: (p) => <PasoClub {...p} states={states} />,
			falta: faltaClub,
		},
		{
			id: "horarios",
			titulo: "¿Cuándo se alquila?",
			bajada:
				"Qué deportes se juegan, los días y el horario del club, y cuánto puede durar cada turno. Los turnos se arman solos.",
			render: (p) => <PasoHorarios {...p} />,
			falta: faltaHorarios,
		},
		{
			id: "canchas",
			titulo: "Tus canchas y precios",
			final: "Abrir canchas",
			bajada:
				"Cada cancha con su precio base para cada duración. No sugerimos precios: ponés los tuyos.",
			render: (p) => <PasoCanchas {...p} />,
			falta: faltaCanchas,
		},
	],
	opc: [
		{
			id: "contacto",
			titulo: "Contacto y descripción",
			seccion: "Información general",
			bajada:
				"Lo que ven los jugadores en la página del club para conocerte y escribirte.",
			render: (p) => <PasoContacto {...p} lugar="club" />,
			falta: faltaContacto,
		},
		{
			id: "fotos",
			titulo: "Fotos del club",
			seccion: "Información general",
			bajada:
				"La portada encabeza la página del club; la galería muestra las canchas.",
			render: (p) => <PasoFotos {...p} />,
			falta: () => "",
		},
		{
			id: "servicios",
			titulo: "Servicios y categorías",
			seccion: "Deportes y servicios",
			bajada:
				"Los servicios aparecen en los filtros de búsqueda. Las categorías sirven para agrupar canchas.",
			render: (p) => <PasoServicios {...p} />,
			falta: () => "",
		},
		{
			id: "politicas",
			titulo: "Políticas de reserva",
			seccion: "Políticas",
			bajada: "Reglas que se aplican a todos los turnos del club.",
			render: (p) => <PasoPoliticas {...p} conVentana />,
			falta: () => "",
		},
		{
			id: "detalle",
			titulo: "Detalle de cada cancha",
			seccion: "Canchas",
			bajada: "Cómo es cada cancha y si pide seña para reservar.",
			render: (p) => <PasoDetalle {...p} senasBloqueadas={senasBloqueadas} />,
			falta: faltaDetalle,
		},
		{
			id: "reglas",
			titulo: "Precios por día y horario",
			seccion: "Canchas",
			bajada:
				"Para cobrar distinto según el momento, por ejemplo más caro de noche o los fines de semana. Si no cargás ninguna, rige el precio base.",
			render: (p) => <PasoReglas {...p} senasBloqueadas={senasBloqueadas} />,
			falta: faltaReglas,
		},
	],
});
